import axios from "axios";
import user from "./user";
import config from "./config";
import NProgress from "nprogress";

const http = axios.create({
  baseURL: config.get("VUE_APP_API_BASE_URL"),
  timeout: config.get("VUE_APP_HTTP_TIMEOUT") || 200000,
  headers: {
    ...(user.getToken() && {
      Authorization: `Bearer ${user.getToken().access_token}`,
    }),
    ...(user.getActiveBranch() && { "active-branch": user.getActiveBranch() }),
  },
});

http.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

// before a response is returned stop nprogress
http.interceptors.response.use(response => {
  NProgress.done();
  return response;
});

export default http;
